import type { TabMenuOption } from '@/_components/tab-menu/types';
import yup from '@/infra/YupDecorator';
import type { ILocation } from '@/Interfaces/Data';
import { FARE_OF_TYPE, FareTabItems, FareTabItemsLabel } from './types';

const CODIGO_IBGE_REGEX = /\b\d{7}\b/;

export const DEFAULT_LOCATION_BRASIL: ILocation = {
  latitude: -12.2410026,
  longitude: -51.6357769,
};

export const ADDRESS_AUTOCOMPLETE_ID = 'address-autocomplete';

export const franchiseFormSchema = yup.object({
  nome: yup.string().when('establishmentName', {
    is: (establishmentName: string | undefined) => !establishmentName,
    then: schema => schema.required(),
    otherwise: schema => schema.optional(),
  }), // Obrigatório quando for franquia
  uf: yup.string().when('establishmentName', {
    is: (establishmentName: string | undefined) => !establishmentName,
    then: schema => schema.required(),
    otherwise: schema => schema.optional(),
  }), // Obrigatório quando for franquia
  ufInitials: yup.string().optional(),
  placeId: yup.string().optional(),
  establishmentName: yup.string().optional(),
  cityId: yup.string().optional(),
  cityName: yup.string().optional(),
  fareOfType: yup.string().when('establishmentName', {
    is: (establishmentName: string | undefined) => !establishmentName,
    then: schema =>
      schema.required().oneOf([FARE_OF_TYPE.KM, FARE_OF_TYPE.NEIGHBORHOOD]),
    otherwise: schema =>
      schema.optional().oneOf([FARE_OF_TYPE.KM, FARE_OF_TYPE.NEIGHBORHOOD]),
  }), // Obrigatório quando for franquia
  codigoIbge: yup.string().when('establishmentName', {
    is: (establishmentName: string | undefined) => !establishmentName,
    then: schema =>
      schema
        .required()
        .matches(CODIGO_IBGE_REGEX, { message: 'Código IBGE inválido' }),
    otherwise: schema =>
      schema
        .optional()
        .matches(CODIGO_IBGE_REGEX, { message: 'Código IBGE inválido' }),
  }), // Obrigatório quando for franquia
  localizacao: yup
    .object({
      latitude: yup.number().optional(),
      longitude: yup.number().optional(),
    })
    .when('establishmentName', {
      is: (establishmentName: string | undefined) => !establishmentName,
      then: schema => schema.required(),
      otherwise: schema => schema.optional(),
    }), // Obrigatório quando for franquia
  entregaBaseKm: yup.number().required().positive(),
  raioMaxDistance: yup.number().required().positive(),
  maxDistanceDropsToGroup: yup.number().required().positive(),
  qtdMaxEntregaGroup: yup.number().required().positiveOr0(),
  valorEntregaBase: yup
    .number()
    .required()
    .positiveOr0()
    .moreThan(yup.ref('taxaEntregaBase'), 'Deve ser maior que a taxa'),
  taxaEntregaBase: yup.number().required(),
  valorKmAdicional: yup.number().required().positiveOr0(),
  taxaEntregaKmAdicional: yup.number().required().positiveOr0(),
  minDistanceCloseTo: yup.number().required().positiveOr0(),
  requiredReturnToConfirmPayMethods: yup.array().default([]),
  requiredNearPlaceToConfirm: yup.boolean().required(),
  bairros: yup
    .array()
    .of(
      yup.object({
        name: yup.string().optional(),
        logFee: yup.number().optional(),
        deliveryValue: yup.number().optional().positive(),
        latitude: yup.number().when('name', {
          is: (val: string | undefined) => !!val,
          then: schema => schema.required(),
          otherwise: schema => schema.optional(),
        }),
        longitude: yup.number().when('name', {
          is: (val: string | undefined) => !!val,
          then: schema => schema.required(),
          otherwise: schema => schema.optional(),
        }),
        isActive: yup.boolean().optional(),
      }),
    )
    .default([])
    .optional(),
});

export const FARE_TAB_OPTIONS: TabMenuOption<FareTabItems>[] = [
  {
    key: FareTabItems.NEIGHBORHOOD,
    text: FareTabItemsLabel[FareTabItems.NEIGHBORHOOD],
    value: FareTabItems.NEIGHBORHOOD,
  },
  {
    key: FareTabItems.MAP,
    text: FareTabItemsLabel[FareTabItems.MAP],
    value: FareTabItems.MAP,
  },
];
